import styled from 'styled-components';

import Row from 'xpi-black-ui/Base/Grid/Row/styles';
import KeyValue from 'xpi-black-ui/Common/KeyValue/styles';
import ContentBox from 'xpi-black-ui/Base/ContentBox/styles';

export default styled.div`
  ${ContentBox} {
    margin-bottom: 0;
  }

  ${Row} {
    flex-wrap: wrap;
    margin-left: -24px;
  }

  ${KeyValue} {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 30.6%;
    margin-left: 24px;
    margin-bottom: 24px;
  }
`;
